/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import Hidden from '@material-ui/core/Hidden';
import { PDFViewer, PDFDownloadLink, Page, Text, View, Document, StyleSheet, Font, Svg, Polygon, Line } from 'react-pdf-renderer-v2';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { login, logoff,loadUserFromStorage } from "_services/oauth";
import axios from "axios";
import { authHeader } from "_helpers";
import store from "store";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";

import "react-datetime/css/react-datetime.css"
import "../../views/Leave/custom-style.css"
Font.register({
  family: 'thsarabun',
  src: '/thsarabun.ttf'
});
 
Font.register({
  family: 'thsarabunbold',
    src: '/thsarabunbold.ttf'
});

const styles = StyleSheet.create({
  body: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingHorizontal: 30,
  },
  title: {
      fontSize: 22,
      textAlign: 'center',
      fontFamily: 'thsarabunbold',
  },
  author: {
      fontSize: 16,
      textAlign: 'right',
      fontFamily: 'thsarabun'
  },
  subtitle: {
      fontSize: 16,
      margin: 5,
      fontFamily: 'thsarabunbold',
  },
  subtitle2: {
      fontSize: 16,
      margin: 5,
      fontFamily: 'thsarabun',
  },
  textBold: {
      marginLeft: 5,
      marginTop: 2,
      marginBottom: 1,
      fontSize: 16,
      textAlign: 'justify',
      fontFamily: 'thsarabunbold',
  },
  text: {
      marginLeft: 5,
      marginTop: 2,
      marginBottom: 1,
      fontSize: 16,
      textAlign: 'justify',
      fontFamily: 'thsarabun',
  },
  text14: {
      fontSize: 14,
      textAlign: 'justify',
      fontFamily: 'thsarabun'
  },
  textCenter: {
      fontSize: 16,
      textAlign: 'center',
      fontFamily: 'thsarabun'
  },
  image: {
      marginVertical: 15,
      marginHorizontal: 100,
  },
  header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey',
      fontFamily: 'thsarabun'
  },
  pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
  },

  row: {
      flex: 1,
      flexDirection: 'row',
      flexGrow: 1,
      marginTop: 10,
  },
  left: {
      // width: '33%',//<- working alternative
      flexGrow: 1,
      flexShrink: 1,
      padding: 5,
      flex: 1,
  },
  right: {
      // width: '66%', //<- working alternative
      flexShrink: 1,
      flexGrow: 1,
      padding: 5,
      flex: 1,
  },
  table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0
  },
  tableRow: {
      margin: "auto",
      flexDirection: "row"
  },
  tableCol: {
      width: "25%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
  },
  tableColMerge: {
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
  },
  tableCell: {

      marginTop: 5,
      fontSize: 16,
      textAlign: 'center',
      fontFamily: 'thsarabun'
  },
  checkbox: {
      height: 21,
      width: 31,
      display: 'inline-block',
      marginTop: -3,
      marginRight: -15
  },
  box: {
      points: "5,10 15,10 15,20 5,20",
      stroke: "black",
      strokeWidth: 1,
  },



});



const TSLeaveForm = props => {

  const { location, ...other } = props;
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();

  var moment = require('moment');
  require('moment/locale/th');

    const [LeaveRequestID, setLeaveRequestID] = useState('');
    const [LeaveTypeKey, setLeaveTypeKey] = useState(null);
    const [LeaveTypeName, setLeaveTypeName] = useState(null);
  const [IsUrgent, setIsUrgent] = useState(false);
  const [EnabledUrgent, setEnabledUrgent] = useState(false);
  const [StartDate, setStartDate] = useState("");
  const [StartType, setStartType] = useState(0);

  const [IsMoreDate, setIsMoreDate] = useState(false);
  const [EndDate, setEndDate] = useState("");
  const [CreateDT, setCreateDT] = useState("");
  const [EndType, setEndType] = useState(0);
  const [LeaveReason, setLeaveReason] = useState('');

  const [ContactAddress, setContactAddress] = useState('');
  const [ContactPhone, setContactPhone] = useState('');

  const [TotalDate, setTotalDate] = useState(1);
  const [TotalHistory, setTotalHistory] = useState(0);
  const [TotalAll, setTotalAll] = useState(0);
  const [RequestBefore, setRequestBefore] = useState(0);
    const [Accrued, setAccrued] = useState(0);
    const [MaxOnly, setMaxOnly] = useState(0);
  const [FullName, setFullName] = useState('');
  const [PositionName, setPositionName] = useState('');
  const [TypeGovName, setTypeGovName] = useState('');




  const [modalHoliday, setModalHoliday] = useState(false);
  const [holidayText, setHolidayText] = useState('');
  const [currentDate, setcurrentDate] = useState(moment());
  const [holidays, setHolidays] = useState([]);

  const [isHovered, setIsHovered] = useState(false);


  const [ArrLeaveType, setArrLeaveType] = useState([]);
  const [ArrStandin, setArrStandin] = useState([]);
  const [ArrDepartmentBoss, setArrDepartmentBoss] = useState([]);
  const [ArrGroupworkBoss, setArrGroupworkBoss] = useState([]);
  const [ArrMissionBoss, setArrMissionBoss] = useState([]);
  const [LeaveApprove, setLeaveApprove] = useState([]);

  const [FlowLevel, setFlowLevel] = useState([]);

  const [LeaveHistory, SetLeaveHistory] = useState("");

  const [Standin, SetStandin] = useState("");
  const [DepartmentBoss, SetDepartmentBoss] = useState("");
    const [GroupworkBoss, SetGroupworkBoss] = useState("");
    const [MissionBoss, SetMissionBoss] = useState("");
    const [HR, SetHR] = useState("");
    const [Director, SetDirector] = useState("");

    const [StandinTxt, SetStandinTxt] = useState("");
    const [DepartmentBossTxt, SetDepartmentBossTxt] = useState("");
    const [GroupworkBossTxt, SetGroupworkBossTxt] = useState("");
    const [MissionBossTxt, SetMissionBossTxt] = useState("");
    const [HRTxt, SetHRTxt] = useState("");
    const [DirectorTxt, SetDirectorTxt] = useState("");

    const [StandinApprove, setStandinApprove] = useState(null);
    const [DepartmentApprove, setDepartmentApprove] = useState(null);
    const [GroupworkApprove, setGroupworkApprove] = useState(null);
    const [MissionApprove, setMissionApprove] = useState(null);
    const [HRApprove, setHRApprove] = useState(null);
    const [DirectorApprove, setDirectorApprove] = useState(null);

    const [IsDirector, setIsDirector] = useState(false);

    const [LeaveHisText, SetLeaveHisText] = useState("");


  const [GroupText, SetGroupText] = useState("");

  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");

  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [dateFocus, setDateFocus] = useState(false);

  const urgentList = [{ label:"ปกติ", value:0}, { label:"ด่วน", value:1} , { label:"ฉุกเฉิน", value:2}];
  const dateTypeList = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} , { label:"ครึ่งวันบ่าย", value:2}];
  const dateTypeList2 = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} ];


useEffect(() => {

  setLeaveRequestID(props.LeaveRequestID !== null ? props.LeaveRequestID : '')
  setIsEdit(props.LeaveRequestID !== null && props.LeaveRequestID != '');


  if(props.LeaveRequestID != null && props.LeaveRequestID != '' )
  {
    var _alt = [];
      axios.post("/api/v1/leave/type", { "IsApprove": true, "LeaveRequestID": 
        //(isEdit ? LeaveRequestID: '00000000-0000-0000-0000-000000000000')})
        (props.LeaveRequestID)})
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"name":').join('"label":').split('"leaveTypeKey":').join('"value":')*/);
            setArrLeaveType(json)
            _alt = json;
        }, error => { console.log(error); }
    );  

    axios.post("/api/v1/myteam", {userName: "" })
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);
            
            const myteam = json.map((o) => ({
              ...o,
              value: o.userName,
              label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
            }));
            
            const jsonMy = myteam.filter(e => e.userName == result.data.userName)[0];

            if(!isEdit){
              setContactPhone(jsonMy.userProfile.mobilePhone);
              setContactAddress(jsonMy.userProfile.address);
            }

            const jsonStanin = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey != 3)
            setArrStandin(jsonStanin)

            const jsonDept = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey == 1 && jsonMy.userLevelKey < 1 /*e.userLevelKey == jsonMy.userLevelKey*/)
            setArrDepartmentBoss(jsonDept)

            const jsonGroup = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey == 2 && jsonMy.userLevelKey < 2)
            setArrGroupworkBoss(jsonGroup)

            const jsonMission = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 || e.userLevelKey == 3))
            setArrMissionBoss(jsonMission)


        }, error => { console.log(error); }
    );  

      axios({
          method: 'get',
          url: "/api/v1/lastleave/" + props.LeaveRequestID,
          //headers: { 'referpage': '/leave/request/' + props.LeaveRequestID }
      })
      .then(
          resEdit => {
              SetLeaveHisText(resEdit.data.data)
        },
        error => {

        }
     ); 
    

    axios({
      method: 'get',
        url: "/api/v1/leave/" + props.LeaveRequestID,
        headers: { 'referpage': '/leave/request/' + props.LeaveRequestID }
    })
    .then(
        resEdit => {
          var res=resEdit.data.data;
          setLeaveTypeKey(res.leaveTypeKey)
 
          var _leaveText = (_alt != "") ? _alt.find(t => t.value == res.leaveTypeKey).label : "";
            setLeaveTypeName(_leaveText)

          setStartDate(moment(res.startDate).format('YYYY-MM-DD').toString())
          setStartType(res.startDateType)
          setEndDate(moment(res.endDate).format('YYYY-MM-DD').toString())
          setEndType(res.endDateType)


          setIsUrgent(res.isUrgent)

          setCreateDT(moment(res.createDT).format('YYYY-MM-DD').toString())

          //handleLeaveType(_alt, res.leaveTypeKey, moment(res.startDate))
          //ให้ดึงสถิติจากที่บันทึกใน record (ไม่คำนวนใหม่เพราะจะสับสน) คำนวนใหม่เมื่อต้องการจะแก้ไข และเลือกวันใหม่
          var his = _alt.find(t => t.leaveTypeKey == res.leaveTypeKey);
          //console.log(his)
          var txt = 'ใช้วันลาแล้ว '; 
          var dt = (moment(res.startDate).isValid()) ? moment(res.startDate) : moment();
      
          if(his != null){
            if(his.maxLeave != null && his.maxLeave  > 0) {
              txt += res.totalHistory + '/'+ res.totalAll + ' วัน';
            }
            else{
              if(dt.format('M') >=4 && dt.format('M') <= 9){
                txt += res.totalHistory + '/'+ res.totalAll + ' วัน (ครึ่งปีหลัง)';  
              }         
              else{
                txt += res.totalHistory + '/'+ res.totalAll+ ' วัน (ครึ่งปีแรก)';
              }
            }
            
            setTotalHistory(res.totalHistory);
              setTotalAll(res.totalAll);

              setAccrued(his.accrued)
              setMaxOnly(his.maxOnly)
      
            setEnabledUrgent(his.enabledUrgent == 1)
            setRequestBefore(his.requestBefore)
            SetLeaveHistory(txt);

          }

          setFullName(res.userView.titleName+res.userView.firstName+' '+res.userView.lastName)

          var group = res.userView.userDepartment.find(t => t.isDefault == true);
          
          var _dep = (group != null && group.department != null) ? group.department : '';
          var _gw = (_dep != null && _dep.groupWork != null) ? _dep.groupWork : '';
          var _mission = (_gw != null && _gw.mission != null) ? _gw.mission : '';

          var fullText = _dep.name+' '+ _gw.name+' '+_mission.name;

          SetGroupText(fullText)

          setPositionName(res.userView.positionName)
          setTypeGovName(res.userView.typeGov.name)

          setLeaveReason(res.leaveDesc)

          setContactAddress(res.contactAddress)
          setContactPhone(res.contactPhone)

          setTotalDate(res.totalDate)

          setIsMoreDate(moment(res.startDate) != moment(res.endDate))

          var _standin = res.leaveApprove.find(t => t.approveTypeKey == 5);
          if (_standin != null) {
              SetStandin(_standin.approveUserName);
              SetStandinTxt((_standin.userView.titleName != null ? _standin.userView.titleName : '') + _standin.userView.firstName + ' ' + _standin.userView.lastName);
              setStandinApprove(_standin);
          }
               
            var _dept = res.leaveApprove.find(t => t.approveTypeKey == 4);
            if (_dept != null) {
                SetDepartmentBoss(_dept.approveUserName);
                SetDepartmentBossTxt((_dept.userView.titleName != null ? _dept.userView.titleName : '') + _dept.userView.firstName + ' ' + _dept.userView.lastName);
                setDepartmentApprove(_dept);
            }

            var _gw = res.leaveApprove.find(t => t.approveTypeKey == 3);
            if (_gw != null) {
                SetGroupworkBoss(_gw.approveUserName);
                SetGroupworkBossTxt((_gw.userView.titleName != null ? _gw.userView.titleName : '') + _gw.userView.firstName + ' ' + _gw.userView.lastName);
                setGroupworkApprove(_gw);
            }

            var _mission = res.leaveApprove.find(t => t.approveTypeKey == 2);
            if (_mission != null) {
                SetMissionBoss(_mission.approveUserName);
                SetMissionBossTxt((_mission.userView.titleName != null ? _mission.userView.titleName : '') + _mission.userView.firstName + ' ' + _mission.userView.lastName);
                setMissionApprove(_mission);
            }


            var _hr = res.leaveApprove.find(t => t.approveTypeKey == 0);
            if (_hr != null) {
                SetHR(_hr.approveUserName);
                SetHRTxt((_hr.userView.titleName != null ? _hr.userView.titleName : '') + _hr.userView.firstName + ' ' + _hr.userView.lastName);
                setHRApprove(_hr);

                console.log(_hr)
            }


            var _dr = res.leaveApprove.find(t => t.approveTypeKey == 1);
            if (_dr != null) {
                SetDirector(_dr.approveUserName);
                SetDirectorTxt((_dr.userView.titleName != null ? _dr.userView.titleName : '') + _dr.userView.firstName + ' ' + _dr.userView.lastName);
                setDirectorApprove(_dr);

                console.log(_dr)

                if (_dr.userView != null)
                    setIsDirector(_dr.userView.userDepartment.find(t => t.userLevelKey == 4) != null)
                
            }


          //if(res.leaveApprove.find(t => t.approveTypeKey == 4) != null)
          //  SetDepartmentBoss(res.leaveApprove.find(t => t.approveTypeKey == 4).approveUserName)

          //if(res.leaveApprove.find(t => t.approveTypeKey == 3) != null)
          //  SetGroupworkBoss(res.leaveApprove.find(t => t.approveTypeKey == 3).approveUserName)

          //if(res.leaveApprove.find(t => t.approveTypeKey == 2) != null)
          //  SetMissionBoss(res.leaveApprove.find(t => t.approveTypeKey == 2).approveUserName)
          
          setLeaveApprove(res.leaveApprove);

          handleFlowLevel(res.leaveType.systemTypeKey)

        },
        error => {

        }
    ); 
  }


}, [props.LeaveRequestID]);

  const handleFlowLevel = (stk) => {
      axios.get('/api/v1/flowlevel?SystemKey=1&SystemTypeKey='+stk)
      .then(
        result => {
              setFlowLevel(result.data.data)
  
  
          }, error => { console.log(error); }
      );  
  };


  function renderText() {

    return <Document>
                <Page style={styles.body} wrap size="A4">
                    <Text style={[styles.title, { textDecoration: 'underline' }]}>แบบใบ{LeaveTypeName}</Text>
                    <Text style={styles.author}>เขียนที่ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง</Text>
                    <Text style={styles.author}>วันที่ {moment(CreateDT).format('D MMMM BBBB')}</Text>
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={styles.subtitle}>เรื่อง</Text>
                <Text style={styles.subtitle2}>ขออนุญาต{LeaveTypeName} {IsUrgent ? "(ฉุกเฉิน)":""}</Text>
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={styles.subtitle}>เรียน</Text>
                        <Text style={styles.subtitle2}>ผู้อำนวยการ</Text>
                    </View>

                    <Text style={styles.text}>
                        ข้าพเจ้า {FullName} {TypeGovName} ตำแหน่ง{PositionName}  สังกัด {GroupText} โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                    </Text>
                    <Text style={styles.text}>

                    </Text>
                    <Text style={styles.text}>

                    </Text>

                    {(LeaveTypeKey == 3) ?  /*เฉพาะ ลาพักผ่อน*/
                            <Text style={styles.text}>มีวันลาพักผ่อนสะสม {Accrued} วัน มีสิทธิ์ลาพักผ่อนประจำปีนี้อีก {MaxOnly - TotalHistory} วัน รวมเป็น {Accrued + (MaxOnly - TotalHistory)} วัน</Text>
                            :
                            <></>
                    }

                    <Text style={styles.text}>ขอ{LeaveTypeName}  เนื่องจาก {LeaveReason}</Text>
                    {(moment(StartDate) != moment(EndDate)) ?
                        <Text style={styles.text}>ตั้งแต่วันที่ {moment(StartDate).format('D MMMM BBBB')} {(StartType > 0)? dateTypeList.find(t=>t.value==StartType).label : ""} ถึงวันที่ {moment(EndDate).format('D MMMM BBBB')} {(EndType > 0)? dateTypeList2.find(t=>t.value==EndType).label : ""} มีกำหนด {TotalDate} วัน </Text>
                        :
                        <Text style={styles.text}>วันที่ {moment(StartDate).format('D MMMM BBBB')} {(StartType > 0)? dateTypeList.find(t=>t.value==StartType).label : ""} มีกำหนด {TotalDate} วัน </Text>
                    }

                    <Text style={styles.text}>{LeaveHisText}</Text>

                    {(LeaveTypeKey != 3) ?  /*เฉพาะ ป่วยกิจ*/
                        <></>
                        :
                        <></>
                    }
    
                   

                    <Text style={styles.text}>ในระหว่างลาสามารถติดต่อข้าพเจ้าได้ที่ {ContactAddress} โทร {ContactPhone}</Text>
                    <Text style={styles.text}>ทั้งนี้ไดมอบหมายให้ {StandinTxt} ปฏิบัติหน้าที่แทน</Text>

                    <View style={[styles.row]}>
                        <View style={styles.left}>

                            <View style={styles.table}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColMerge}>
                                        <Text style={styles.tableCell}>สถิติการลาในปีงบประมาณนี้</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>ประเภทการลา</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>ลามาแล้ว</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>ลาครั้งนี้</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>รวม</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{LeaveTypeName}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{TotalHistory}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{TotalDate}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{(TotalHistory+TotalDate)}</Text>
                                    </View>
                                </View>
                            </View>
                    <Text style={styles.textCenter}> </Text>
                    <Text style={styles.text}>ลงชื่อ {(HRApprove != null && HRApprove.approveStatusKey == 2) ? HRTxt : '.......................................'} ผู้ตรวจสอบ </Text>
                            <Text style={[styles.textBold, { textDecoration: 'underline' }]}>งานทรัพยากรบุคคล</Text>
                            <Text style={styles.text}></Text>
                            <View style={{ flexDirection: 'row' }}>
                                <Svg style={styles.checkbox}>
                                    <Polygon style={styles.box} />
                                     {/*<Line x1="20" y1="5" x2="7" y2="20" strokeWidth={2} stroke="black" />
                                    <Line x1="7" y1="20" x2="4" y2="15" strokeWidth={2} stroke="black" />
                                    */}
                                </Svg>
                                <Text style={styles.text}>ได้ตรวจสอบการลาและสิทธิในการลาถูกต้องตามระเบียบแล้ว</Text>
                            </View>


                    {(LeaveTypeKey != 3) ?  //ไม่ใช่ลาพักผ่อน
                        <>
                            <Text style={styles.text}>เป็นการ {LeaveTypeName}</Text>
                            <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                                <Svg style={styles.checkbox}>
                                    <Polygon style={styles.box} />
                                    {/*<Line x1="20" y1="5" x2="7" y2="20" strokeWidth={2} stroke="black" />
                                    <Line x1="7" y1="20" x2="4" y2="15" strokeWidth={2} stroke="black" />
                                    */}
                                </Svg>
                                <Text style={styles.text}>โดยได้รับเงินเดือน</Text>
                            </View>
                            <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                                <Svg style={styles.checkbox}>
                                    <Polygon style={styles.box} />

                                </Svg>
                                <Text style={styles.text}>โดยไม่ได้รับเงินเดือน </Text>
                            </View>
                            <Text style={styles.text}>กรณี.................................................................................................</Text>
                            <Text style={styles.text}>โดยแจ้งให้ฝ่ายการเงินฯเพื่อดำเนินการต่อไป</Text>

                        </>
                        :
                        <></>
                    }



                            
                            <View style={{ flexDirection: 'row' }}>
                                <Svg style={styles.checkbox}>
                                    <Polygon style={styles.box} />
                                    {/*<Line x1="20" y1="5" x2="7" y2="20" strokeWidth={2} stroke="black" />
                                    <Line x1="7" y1="20" x2="4" y2="15" strokeWidth={2} stroke="black" />
                                    */}
                                </Svg>
                                <Text style={styles.text}>ผู้ขอลาได้มอบหมายงานเรียบร้อยแล้ว</Text>
                            </View>
                            <Text style={styles.text}>อื่นๆ.................................................................................................</Text>

                            <Text style={styles.textCenter}> </Text>
                            <Text style={styles.textCenter}>จึงเรียนมาเพื่อโปรดพิจารณาอนุญาต</Text>
                            <Text style={styles.textCenter}> </Text>
                            <Text style={styles.textCenter}>(ลงชื่อ) {(HRApprove != null && HRApprove.approveStatusKey == 2) ? HRTxt : '....................................................'}</Text>
                            <Text style={styles.textCenter}>{(HRApprove != null && HRApprove.approveStatusKey == 2) ? HRTxt : '....................................................'}</Text>
                            <Text style={styles.textCenter}>{(HRApprove != null && HRApprove.approveStatusKey == 2) ? HRApprove.userView.positionName : '....................................................'}</Text>
                            <Text style={styles.textCenter}>วันที่ {(HRApprove != null && HRApprove.approveStatusKey == 2) ? moment(HRApprove.approveDT).format('D MMM BBBB').toString() : '....................................................'}</Text>
                            <Text style={styles.textCenter}> </Text>



                        </View>






                        <View style={[styles.right]}>
                            <Text style={styles.textCenter}>ขอแสดงความนับถือ</Text>
                            <Text style={styles.textCenter}> </Text>
                            <Text style={styles.textCenter}>(ลงชื่อ) {FullName} </Text>
                            <Text style={styles.textCenter}>({FullName})</Text>

                            <Text style={styles.textCenter}> </Text>
                    <Text style={styles.text14}>&nbsp;ปฏิบัติหน้าที่แทน {(StandinApprove != null && StandinApprove.approveStatusKey == 2) ? StandinTxt : '.......................................................................'}</Text>
                    <Text style={styles.text14}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;หัวหน้างาน {(DepartmentApprove != null && DepartmentApprove.approveStatusKey == 2) ? DepartmentBossTxt : '.......................................................................'}</Text>
                    <Text style={styles.text14}>&nbsp;&nbsp;&nbsp;หัวหน้ากลุ่มงาน {(GroupworkApprove != null && GroupworkApprove.approveStatusKey == 2) ? GroupworkBossTxt : '.......................................................................'}</Text>


                            <Text style={styles.textCenter}> </Text>
                            <Text style={styles.textCenter}>ความเห็นผู้บังคับบัญชา {(MissionApprove != null && MissionApprove.approveStatusKey == 2) ? MissionApprove.approveDescription : '.......................................'}</Text>
                            <Text style={styles.textCenter}> </Text>
                            <Text style={styles.textCenter}>(ลงชื่อ) {(MissionApprove != null && MissionApprove.approveStatusKey == 2) ? MissionBossTxt : '.....................................................................................'}</Text>
                            <Text style={styles.textCenter}>{(MissionApprove != null && MissionApprove.approveStatusKey == 2) ? MissionApprove.userView.positionName : '.......................................................................................................'} </Text>
                            <Text style={styles.textCenter}>{(MissionApprove != null && MissionApprove.approveStatusKey == 2) ? moment(MissionApprove.approveDT).format('D MMM BBBB').toString() : '....................................................'}</Text>
                            <Text style={styles.textCenter}> </Text>

                            <Text style={styles.textCenter}> </Text>

                            <View style={{ paddingLeft: 40 }}>
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[styles.textBold, { textDecoration: 'underline' }]}>คำสั่ง</Text>
                                <View style={{ flexDirection: 'row', paddingLeft: 20 }}>
                                {(DirectorApprove != null && DirectorApprove.approveStatusKey == 2) ?
                                    <Svg style={styles.checkbox}>
                                        <Polygon style={styles.box} />
                                        <Line x1="20" y1="5" x2="7" y2="20" strokeWidth={2} stroke="black" />
                                        <Line x1="7" y1="20" x2="4" y2="15" strokeWidth={2} stroke="black" />
                                    </Svg>
                                    :
                                    <Svg style={styles.checkbox}>
                                        <Polygon style={styles.box} />
                                    </Svg>
                                }
                                    <Text style={styles.text}>อนุญาต</Text>
                                </View>


                                <View style={{ flexDirection: 'row', paddingLeft: 20 }}>
                                {(DirectorApprove != null && DirectorApprove.approveStatusKey == -1) ?
                                    <Svg style={styles.checkbox}>
                                        <Polygon style={styles.box} />
                                        <Line x1="20" y1="5" x2="7" y2="20" strokeWidth={2} stroke="black" />
                                        <Line x1="7" y1="20" x2="4" y2="15" strokeWidth={2} stroke="black" />
                                    </Svg>
                                    :
                                    <Svg style={styles.checkbox}>
                                        <Polygon style={styles.box} />
                                    </Svg>
                                }

                                        <Text style={styles.text}>ไม่อนุญาต</Text>
                                    </View>
                                </View>
                            </View>
                    <Text style={styles.textCenter}> </Text>





 
                    
                    <Text style={styles.textCenter}>(ลงชื่อ) {(DirectorApprove != null && DirectorApprove.approveStatusKey == 2) ? DirectorTxt : '.....................................................................................'}</Text>
                    <Text style={styles.textCenter}>({(DirectorApprove != null && DirectorApprove.approveStatusKey == 2) ? DirectorTxt : '.......................................................................................................'})</Text>

                    {(DirectorApprove != null && DirectorApprove.approveStatusKey == 2) ?
                        (!IsDirector) ?
                            <Text style={styles.textCenter}>{DirectorApprove.userView.positionName + ' รักษาราชการแทน'} </Text>:<></>
                        :
                        <Text style={styles.textCenter}>{'.......................................................................................................'} </Text>
                    }

                    <Text style={styles.textCenter}>{(DirectorApprove != null && DirectorApprove.approveStatusKey == 2) ? 'ผู้อำนวยการโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง' : '.......................................................................................................'} </Text>

                    {/*
                            <Text style={styles.textCenter}>(ลงชื่อ).................................................... </Text>
                            <Text style={styles.textCenter}>นายแพทย์ วรพล เวชชาพินันท์</Text>
                            <Text style={styles.textCenter}>ผู้อำนวยการโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง</Text>
                    */}


                            <Text style={styles.textCenter}>วันที่ {(DirectorApprove != null && DirectorApprove.approveStatusKey == 2) ? moment(DirectorApprove.approveDT).format('D MMM BBBB').toString() : '....................................................'} </Text>
                            <Text style={styles.textCenter}> </Text>


                        </View>
                    </View>

                </Page>
            </Document>; 

}


  return (
    <>
    <Hidden xsDown>
      <PDFViewer height={window.innerHeight} width={'100%'} style={{ position: 'relative', border: 0, height: '100%', width: '100%' }} >
        {renderText()}
      </PDFViewer>
    </Hidden>

    <Hidden smUp>
      <PDFDownloadLink document={renderText()} fileName="leave.pdf"  >
        {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : 
                <Button
                        color="info"
                        startIcon={<i className={"fa fa-save"}></i>}  
                >
                เปิดดูใบลา
                </Button>
        }
      </PDFDownloadLink>
    </Hidden>
    </>


  );
}

export default TSLeaveForm;
